import { render, staticRenderFns } from "./applePay.vue?vue&type=template&id=a380b0ba&scoped=true&"
import script from "./applePay.vue?vue&type=script&lang=js&"
export * from "./applePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a380b0ba",
  null
  
)

export default component.exports